import universityCodes from './universityCodes';
// When licensed with university change this key value pair with real values
const universityDomains = {
  ...(process.env.REACT_APP_ENVIRONMENT !== 'production'
    ? { 'gmail.com': universityCodes.OREGONSTATE_EDU }
    : {}),
  [universityCodes.NWMISSOURI_EDU]: universityCodes.NWMISSOURI_EDU,
  [universityCodes.OREGONSTATE_EDU]: universityCodes.OREGONSTATE_EDU,
  [universityCodes.WSU_EDU]: universityCodes.WSU_EDU,
  [universityCodes.EWU_EDU]: universityCodes.EWU_EDU,
  [universityCodes.WOU_EDU]: universityCodes.WOU_EDU,
  [universityCodes.APSU_EDU]: universityCodes.APSU_EDU,
};

export const getUniversityDomain = (email) => {
  const domains = Object.keys(universityDomains);
  const key = domains.find((domain) => email.endsWith(domain));
  return universityDomains[key];
};

export default universityDomains;
